module.exports = __webpack_public_path__ + "img/arrow.a096603f.svg";